<div class="container">
  <div class="non-renewing-container p-3">
    <div class="non-renewing-info">
      <h5 class="mb-3">{{ 'non-renewing.title' | translate }}</h5>
      <p class="description font-size-14">{{ 'non-renewing.description' | translate }}</p>
    </div>

    <a
      routerLink="/register/upgrade-member"
      class="register btn btn-primary bg-primary text-white border-0 fw-bold font-size-14"
      >{{ 'non.renewing.upgrade.button' | translate }}</a
    >
  </div>
</div>
